import axios from "axios";
import { ENROLLMENT_OPEN } from "../config/enrollment";
import { getFreshIdToken } from "../utils/authToken";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// register User to a course
export const registerToCourse = async (courseID, user) => {
  // checks if user is logged in
  if (!user) {
    console.error("No user is logged in!");
    return;
  }

  // The SDK's current token, not the snapshot on `user`: the backend refuses
  // revoked tokens, and a password change in Account settings revokes the one
  // that snapshot holds while this tab stays open.
  const body = {
    "token": await getFreshIdToken(user.accessToken),
    "courseID": courseID
  };

  try {
    const response = await axios.post(API_BASE_URL + "/codenec/register-to-course", body);
  } catch (error) {
    console.error("Error fetching user response:", error);
  }


};

export const setLessonAsCompleted = async (lessonId, userID) => {

  const body = {
    "userID": userID,
    "lessonId": lessonId
  };

  try {
    const response = await axios.put(API_BASE_URL + "/codenec/lesson-completed", body, { withCredentials: true, });
  } catch (error) {
    console.error("Error fetching user response:", error);
  }
};


export const setProblemAsCompleted = async (lessonID, problemID, userID, userRole) => {

  if (userRole == "anonymous") {

  }

  const body = {
    "lessonID": lessonID,
    "problemID": problemID,
    "userID": userID,
    "userRole": userRole

  };

  try {
    const response = await axios.put(API_BASE_URL + "/codenec/problem-completed", body, { withCredentials: true, });

  } catch (error) {
    console.error("Error fetching user response:", error);
  }

};


export const getAllRegisteredCourses = async (paraUser) => {

  const queryParams = {
    "userID": paraUser.uid,
  };

  try {

    const response = await axios.get(API_BASE_URL + "/codenec/registered-courses", {
      params: queryParams
    });

    const courseArray = response.data;

    return courseArray;




  } catch (error) {
    console.error("Error getAllRegisteredCourses: ", error);
    return [];
  }
}

// OLD LOGIN SERVICE
// export const loginUser = async (userName, password) => {

//     const body = {
//         "userName": userName,
//         "password": password
//     };

//     try {
//         const response = await axios.post(API_BASE_URL + "/codenec/login", body, { withCredentials: true, });
//         return response.data.session.user

//     } catch (error) {
//         console.error("Error fetching user response:", error);
//     };

// };


export const loginUserSessionService = async (token) => {

  const body = {
    "token": token,
  };

  try {
    const response = await axios.post(API_BASE_URL + "/codenec/login", body, { withCredentials: true, });
    return response.data.session.user

  } catch (error) {
    console.error("Error fetching user response:", error);
  };

};

export const requestLogOut = async () => {

  try {
    const response = await axios.post(API_BASE_URL + "/codenec/logout", {}, {
      withCredentials: true, // ✅ Ensures session cookie is sent
    });

  } catch (error) {
    console.error("Error fetching user response:", error);
  };


};

// legalAcceptance ({ termsVersion, ageConfirmed, usResidentConfirmed }, see
// config/legal.js) is required by the backend for a NEW profile only.
export const requestSignUp = async (email, role, name, last, token, legalAcceptance) => {

  const body = {
    "email": email,
    "role": role,
    "name": name,
    "last": last,
    "token": token

  };
  if (legalAcceptance) body.legalAcceptance = legalAcceptance;

  try {
    const response = await axios.post(API_BASE_URL + "/codenec/sign-up", body, {
      withCredentials: true, // ✅ Ensures session cookie is sent
    });
    return response.data.session.user

  } catch (error) {
    console.error("Error fetching user response:", error);
  };


};


// Takes an object rather than eight positional arguments because the Security
// tab sends only the fields it is actually changing: leaving `name` and `last`
// out drops them from the JSON body, which is how the backend knows to leave the
// stored profile alone instead of overwriting it with undefined.
export const editAccountService = async ({ name, last, email, password, changeEmail = false, changePassword = false, token }) => {

  const body = {
    "name": name,
    "last": last,
    "email": email,
    "password": password,
    "changeEmail": changeEmail,
    "changePassword": changePassword,
    "token": token,
  };

  // Deliberately no try/catch. Swallowing the error here returned `undefined`,
  // which the caller handed straight to setUser() -- so a rejected save (weak
  // password, email already taken, expired session) silently wiped the logged-in
  // user out of context with nothing on screen to explain it. Let it throw and
  // let the page report what went wrong.
  const response = await axios.put(API_BASE_URL + "/codenec/edit-account", body, { withCredentials: true });
  return response.data.session.user;

};


// Persist the user's selected profile avatar (stores only the avatar id).
export const updateProfileAvatar = async (avatarId, token) => {

  const body = {
    "avatarId": avatarId,
    "token": token,
  };

  try {
    const response = await axios.put(API_BASE_URL + "/codenec/update-avatar", body, { withCredentials: true });
    return response.data;
  } catch (error) {
    console.error("Error updating profile avatar:", error);
    throw error;
  }

};


// Record (per account) that the user has finished/dismissed a HUD walkthrough.
// Best-effort: the localStorage flag is the immediate guard, so failures here
// are non-fatal and intentionally swallowed.
export const requestMarkHudTourSeen = async (hud, token) => {

  const body = {
    "hud": hud,
    "token": token,
  };

  try {
    const response = await axios.put(API_BASE_URL + "/codenec/hud-tour-seen", body, { withCredentials: true });
    return response.data;
  } catch (error) {
    console.error("Error recording HUD tour:", error);
  }

};


export const requestAnonSession = async (token) => {

  const body = {
    "token": token,
  };


  try {
    const response = await axios.post(API_BASE_URL + "/codenec/create-session", body, { withCredentials: true, });
    return response.data.session

  } catch (error) {
    console.error("Error fetching user response:", error);
  };


};

// request set course in anonymous user in the session
export const requestAnonSetCourse = async (courseName, uid, token) => {

  const body = {
    "courseName": courseName,
    "uid": uid,
    "token": token,
  };


  try {
    const response = await axios.put(API_BASE_URL + "/codenec/anonuser-add-course", body, { withCredentials: true, });
    return response.data.session.user

  } catch (error) {
    console.error("Error fetching user response:", error);
  };


};



// RETIRED (2026-10-25): the old monthly/yearly course subscription with a
// 3-day free trial. Its backend route is gone, so nothing can be bought here.
// It is kept only so the reference pages that still call it (/checkout,
// /subscriptions2, /subscriptions3, staff-only now) keep loading. The course is
// sold as a one-time payment: requestCourseCheckout below.
export const requestCheckout = async () => {
  console.warn("The old subscription checkout is retired; nothing was charged.");
  return undefined;
};


// One-time purchase of the CD Course. Returns the Stripe Checkout URL to redirect to.
//
// `eligibility` is the 18+ / US box (CHECKOUT_ELIGIBILITY in config/legal.js);
// the backend refuses a checkout without it. `locale` ("es" | "en") sets the
// language of the Stripe page.
//
// Callers must catch: a refused or failed checkout THROWS an Error carrying
// `code` (the backend's code, e.g. "eligibility_required", or "unknown") and
// `status`. It only returns undefined while enrollment is closed.
export const requestCourseCheckout = async (uid, email, next, { eligibility, locale } = {}) => {

  // Last line of defense while enrollment is closed: the offer pages hide their
  // CTAs; return nothing rather than mint a Stripe session for an unfinished course.
  if (!ENROLLMENT_OPEN) {
    console.warn("Course checkout blocked — enrollment is closed (REACT_APP_ENROLLMENT_OPEN).");
    return undefined;
  }

  const body = {
    uid: uid,
    email: email,
    next: next, // optional: SPA path to return to after payment
    eligibility: eligibility,
    locale: locale

  };

  try {
    const response = await axios.post(API_BASE_URL + "/codenec/course-checkout", body, { withCredentials: true, });
    return response.data

  } catch (error) {
    console.error("Course checkout failed:", error?.response?.status || error?.message);
    const data = error?.response?.data || {};
    const code = typeof data.code === "string"
      ? data.code
      : typeof data.error === "string" && /^[a-z_]+$/.test(data.error) ? data.error : "unknown";
    throw Object.assign(new Error(data.message || "checkout failed"), { code, status: error?.response?.status });
  };

};



export const getUserPortal = async (uid, email) => {

  const body = {
    uid: uid,
    email: email,

  };

  try {
    const response = await axios.post(API_BASE_URL + "/codenec/user-portal", body, { withCredentials: true, });
    return response.data

  } catch (error) {
    console.error("Error fetching user response:", error);
  };

};

export const requestPortal = async () => {

  try {
    const response = await axios.post(API_BASE_URL + "/webhook/portal", {}, { withCredentials: true, });
    return response.data

  } catch (error) {
    console.error("Error fetching user response:", error);
  };

};



export const requestSubscriptionSummary = async (uid) => {

  const body = {
    uid: uid
  };

  try {
    const response = await axios.post(API_BASE_URL + "/codenec/subscription-summary", body, { withCredentials: true, });
    return response.data

  } catch (error) {
    console.error("Error fetching user response:", error);
  };
};


/**
 * Cached lesson content for this user, in this language.
 *
 * `locale` picks which shared pre-generated copy is overlaid — without it the
 * backend serves the English one, which a Spanish hub then rejects and
 * regenerates from Claude on every single visit.
 */
export const requestUserLessonContent = async (paraUser, lessonID, locale = "en") => {


  const queryParams = {
    "userID": paraUser.uid,
    "lessonID": lessonID,
    "role": paraUser.role,
    "locale": locale
  };

  try {

    const response = await axios.get(API_BASE_URL + "/codenec/get-lesson-content", {
      params: queryParams
    });

    const courseArray = response.data;
    return courseArray;




  } catch (error) {
    console.error("Error getAllRegisteredCourses: ", error);
    return [];
  }
}


export const setUserLessonContent = async (user, lessonID, lessonContent, problemsContent) => {

  const body = {
    userID: user.uid,
    lessonID: lessonID,
    lessonContent: lessonContent,
    problemsContent: problemsContent,
    role: user.role

  };

  try {
    const response = await axios.post(API_BASE_URL + "/codenec/set-lesson-content", body, { withCredentials: true, });
    return response.data

  } catch (error) {
    console.error("Error fetching user response:", error);
  };

};



export const requestLessonsData = async (token, courseID) => {

  const queryParams = {
    "token": token,
    "courseID": courseID
  };

  try {
    const response = await axios.get(API_BASE_URL + "/codenec/lessons-data", {
      params: queryParams
    });

    const courseArray = response.data;
    return courseArray;


  } catch (error) {
    console.error("Error getAllRegisteredCourses: ", error);
    return [];
  }
}


export const setUserQuizContent = async (user, lessonID, quizContent, quizScore = null) => {

  const body = {
    userID: user.uid,
    lessonID: lessonID,
    quizContent: quizContent,
    quizScore: quizScore,
    role: user.role

  };

  try {
    const response = await axios.post(API_BASE_URL + "/codenec/set-quiz-content", body, { withCredentials: true, });
    return response.data

  } catch (error) {
    console.error("Error fetching user response:", error);
  };

};


export const setQuizResult = async (user, lessonID, quizScore = null) => {

  const body = {
    userID: user.uid,
    lessonID: lessonID,
    quizScore: quizScore,

  };

  try {
    const response = await axios.post(API_BASE_URL + "/codenec/set-quiz-result", body, { withCredentials: true, });
    return response.data

  } catch (error) {
    console.error("Error fetching user response:", error);
  };

};



export const requestExecuteCode = async (language, code, stdin = "") => {

  const queryParams = {
    "language": language,
    "code": code,
    "stdin": stdin,
  };

  try {

    const response = await axios.get(API_BASE_URL + "/codenec/execute-code", {
      params: queryParams
    });

    return response.data;

  } catch (error) {
    console.error("Error requestExecuteCode: ", error);
    // Surface the failure so callers (CodeExecutor2, Prompt Lab) can show it
    // instead of silently treating an error as empty output.
    const message =
      error?.response?.data?.error || error?.message || "Execution failed";
    throw new Error(message);
  }
}


// ---------------------------------------------------------------------------
// The student's own app project ("Claude AI Developer" course)
//
// Written across two Module 1 lessons — CD107 saves the idea, CD108 saves the
// brand the Template Studio previews — and read back by every later lesson so
// Claude talks about THEIR app. Returns null when nothing is saved yet.
// ---------------------------------------------------------------------------

export const requestMyProject = async (token) => {

  const queryParams = {
    "token": token,
  };

  try {

    const response = await axios.get(API_BASE_URL + "/codenec/my-project", {
      params: queryParams
    });

    return response.data;

  } catch (error) {
    console.error("Error requestMyProject: ", error);
    return null;
  }
}


/**
 * Partial save — pass only the fields this lesson owns; the backend merges them
 * into the existing doc, so CD108 saving the brand can't wipe CD107's idea.
 *
 * @param {object} project  Any subset of { appName, tagline, accentColor, emoji,
 *                          idea, locale, ideaConversation, specComplete }
 */
export const saveMyProject = async (project, token) => {

  const body = {
    "token": token,
    "project": project,
  };

  try {
    const response = await axios.put(API_BASE_URL + "/codenec/my-project", body, { withCredentials: true });
    return response.data;
  } catch (error) {
    console.error("Error saveMyProject: ", error);
    throw new Error(error?.response?.data?.error || error?.message || "Could not save project");
  }
}


/**
 * Signed URL for a lesson's pre-generated narration (ElevenLabs Multilingual v2).
 *
 * The backend looks the prose up by lessonID — the client never sends text — and
 * only a verified token may trigger generation on a cache miss. Returns null on
 * ANY failure (no clip, Storage not enabled, offline): the caller falls back to
 * the browser's built-in voice, so audio degrades instead of disappearing.
 *
 * @returns {Promise<{url: string, cached: boolean, chars: number} | null>}
 */
export const requestLessonAudio = async (lessonID, locale, token) => {

  const body = {
    "lessonID": lessonID,
    "locale": locale,
    "token": token,
  };

  try {
    const response = await axios.post(API_BASE_URL + "/codenec/lesson-audio", body);
    return response.data?.url ? response.data : null;
  } catch (error) {
    // Expected whenever narration isn't available for this lesson yet — noisy
    // console errors here would be misleading, so keep it quiet.
    return null;
  }
}
/**
 * POST /codenec/contact — the public contact form on /contact.
 *
 * The only service call here with no token and no withCredentials: a stranger
 * who has never signed up has to be able to reach us. `website` is the form's
 * honeypot and is expected to be empty; the backend answers 200 and drops the
 * message when it is not.
 *
 * Unlike the older functions in this file this one RETHROWS. The form has to be
 * able to tell someone their message did not send — swallowing the error would
 * show a success screen after a failed request and quietly lose the lead.
 *
 * @returns {Promise<{message: string, emailed: boolean}>}
 */
export const requestSendContactMessage = async ({ name, email, business, message, website, locale }) => {

  const body = {
    "name": name,
    "email": email,
    "business": business,
    "message": message,
    "website": website,
    "locale": locale,
  };

  try {
    const response = await axios.post(API_BASE_URL + "/codenec/contact", body);
    return response.data;
  } catch (error) {
    console.error("requestSendContactMessage failed:", error);
    throw new Error(
      error?.response?.data?.error || error?.message || "Could not send the message"
    );
  }
}

/**
 * Codenec Desktop, step one of pairing: trade a fresh Firebase ID token and
 * the desktop app's PKCE challenge for a one-time code. Called from
 * /desktop-auth after the person clicks Connect; the page then hands the code
 * to the desktop app through a loopback redirect.
 *
 * Rethrows the ORIGINAL axios error rather than swallowing it or wrapping it
 * in a bare Error. The page needs the HTTP status to say the right thing -
 * 401 means sign in again, 429 means slow down, 400 means start over from the
 * app - and a failure that went quiet here would leave the desktop app waiting
 * out its three-minute timeout with no explanation on either screen.
 *
 * No withCredentials: this endpoint authenticates by the token in the body,
 * never by the session cookie.
 *
 * @returns {Promise<{code: string}>}
 */
export const requestDesktopPairStart = async (token, challenge, label) => {

  const body = {
    "token": token,
    "challenge": challenge,
    "label": label,
  };

  try {
    const response = await axios.post(API_BASE_URL + "/codenec/desktop/pair/start", body);
    return response.data;
  } catch (error) {
    console.error("requestDesktopPairStart failed:", error?.response?.status || error?.message);
    throw error;
  }
}


/* -------------------------------------------------------------------------
   Codenec Desktop credits

   Credits pay for model calls made by the desktop app when a client runs on
   Codenec's Anthropic account instead of their own key. They are bought here,
   on the website, because the app deliberately holds no payment surface: it
   has no card details, no Stripe session and nothing to phish.

   All three rethrow the ORIGINAL axios error instead of swallowing it the way
   requestCheckout does. The account page has to tell a 403 ("your account is
   not set up for credits") apart from a 500 ("we broke"), and a caller that
   returns undefined for both can only ever show one message for two very
   different situations.

   Each sends a FRESH ID token in the body - the house convention - because
   these routes verify it. The snapshot on the user object goes stale after an
   hour; see utils/authToken.js.
   ------------------------------------------------------------------------- */

/**
 * Balance, packs on sale, eligibility and recent top-ups, in one call.
 *
 * None of it is readable from Firestore in the browser: the desktop_*
 * collections have no client-SDK rule at all.
 *
 * @returns {Promise<{balance: number, lowWater: number, eligible: boolean,
 *   packs: Array<{id: string, credits: number, priceUsd: number, available: boolean}>,
 *   purchases: Array<object>}>}
 */
export const requestDesktopCredits = async (token) => {

  try {
    const response = await axios.post(API_BASE_URL + "/codenec/desktop/credits", { token });
    return response.data;
  } catch (error) {
    console.error("requestDesktopCredits failed:", error?.response?.status || error?.message);
    throw error;
  }
}

/**
 * Start a Stripe Checkout for one credit pack. Returns { url } to send the
 * browser to.
 *
 * `packId` is the ONLY thing the server takes from here: no price, no credit
 * count, no amount. Those live in the backend catalogue, so the worst a
 * tampered request can do is buy a pack that is already on sale.
 *
 * Deliberately NOT gated on ENROLLMENT_OPEN. That flag closes course
 * enrolment; a client who already owns the desktop app still needs to top up.
 */
export const requestCreditPackCheckout = async (token, packId, next) => {

  const body = {
    "token": token,
    "packId": packId,
    "next": next, // optional: SPA path to return to after payment
  };

  try {
    const response = await axios.post(API_BASE_URL + "/codenec/desktop/credit-checkout", body);
    return response.data;
  } catch (error) {
    console.error("requestCreditPackCheckout failed:", error?.response?.status || error?.message);
    throw error;
  }
}

/**
 * Has the webhook turned this Stripe session into credits yet?
 *
 * Polled by /checkout/success. Answers { granted: false } - not an error - for
 * a session that is unknown, still in flight, or another account's, so the
 * success screen can keep waiting without having to classify failures.
 */
export const requestCreditGrantStatus = async (token, sessionId) => {

  const body = {
    "token": token,
    "sessionId": sessionId,
  };

  try {
    const response = await axios.post(API_BASE_URL + "/codenec/desktop/credit-grant", body);
    return response.data;
  } catch (error) {
    console.error("requestCreditGrantStatus failed:", error?.response?.status || error?.message);
    throw error;
  }
}
